.fullscreen {
	display: block;
	height: 100vh;
	width: 100vw;
	position: fixed;
	top: 0;
	left: 0;
	background-color: var(--elevation-low);
	z-index: 1;
	overflow: auto;
}

.header {
	height: fit-content;
	width: 100%;
	padding: 20px;
	display: flex;
	gap: 8px;
	align-items: end;
	position: fixed;
	z-index: 2;
}

/**
 * Force the close button always to the right
 */
.header > :last-child {
	margin-left: auto;
}

.content {
	width: 560px;
	height: fit-content;
	position: relative;
	left: 50%;
	margin-top: 80px;
	margin-bottom: 20px;
	transform: translateX(-50%);
}
